import {
  AfFilterState,
  AfFilterActionTypes,
  GET_AF_FILTER_LIST,
  GET_AF_FILTER_LIST_FULFILLED,
  GET_AF_FILTER_PENDING,
  GET_AF_FILTER_FULFILLED,
  SELECT_AF_FILTER,
  CREATE_AF_FILTER_PENDING,
  CREATE_AF_FILTER_FULFILLED,
  DELETE_AF_FILTER_FULFILLED,
  OPEN_AF_FILTER_CREATE_POPUP,
  CLOSE_AF_FILTER_CREATE_POPUP,
  SET_AF_FILTER_LOADING,
} from './afFilter.types';

export const initialState: AfFilterState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function afFilterReducer(
  state = initialState,
  action: AfFilterActionTypes,
): AfFilterState {
  switch (action.type) {
    case GET_AF_FILTER_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_AF_FILTER_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_AF_FILTER_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_AF_FILTER_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_AF_FILTER:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_AF_FILTER_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_AF_FILTER_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_AF_FILTER_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_AF_FILTER_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

      case OPEN_AF_FILTER_CREATE_POPUP:
        return {
          ...state,
          single: action.payload.afFilter ?? null,
          createdId: null,
          ui: {
            ...state.ui,
            isCreatePopupOpen: true,
          },
        };

      case CLOSE_AF_FILTER_CREATE_POPUP:
        return {
          ...state,
          ui: {
            ...state.ui,
            isCreatePopupOpen: false,
          },
        };

    default:
      return state;
  }
}
